export default function LocalStorageProvider() {
  this.$get = () => {
    'ngInject';

    function LocalStorageProvider() {

      const self = this;

      self.put = (key, value) => {
        try {
          localStorage[key] = JSON.stringify(value);
        } catch (e) {
          console.log(e);
        }
      }

      self.get = (key, defaultValue) => {
        try {
          const value = localStorage[key];
          if (value) {
            return JSON.parse(value);
          }

          return defaultValue;
        } catch (e) {
          console.log(e);
          return undefined;
        }
      }

      self.remove = (key) => {
        try {
          delete localStorage[key];
        } catch (e) {
          console.log(e);
        }
      };

      self.isExists = (key) => {
        try {
          if (isSupported()) {
            return !!localStorage[key];
          }

          return false;
        } catch (e) {
          console.log(e);
          return false;
        }
      };

      const isSupported = () => {
        try {
          return 'localStorage' in window && window.localStorage !== null;
        } catch (e) {
          console.log(e);
          return false;
        }
      };

    }

    return new LocalStorageProvider();
  };
}